import { RegExpUtility } from "../../../../library-js/text/RegExpUtility";


export type MON = "MON";
export type TUE = "TUE";
export type WED = "WED";
export type THU = "THU";
export type FRI = "FRI";
export type SAT = "SAT";
export type SUN = "SUN";

export type Weekday = 
  MON |
  TUE |
  WED |
  THU |
  FRI |
  SAT |
  SUN 
;

export class Weekdays
{
  static readonly MON:MON = "MON";
  static readonly TUE:TUE = "TUE";
  static readonly WED:WED = "WED";
  static readonly THU:THU = "THU";
  static readonly FRI:FRI = "FRI";
  static readonly SAT:SAT = "SAT";
  static readonly SUN:SUN = "SUN";

  static get time()
  {
    let time = new Date();

    let hours =   RegExpUtility.prependZeros( time.getHours() + "", 2 );
    let minutes = RegExpUtility.prependZeros( time.getMinutes() + "", 2 );

    return `${hours}:${minutes}`;
  }

  static get today()
  {
    return Weekdays.fromDateDayIndex( new Date().getDay() );   
  }

  static fromDateDayIndex( index:number )
  {
    switch ( index )
    {
      case 0: return Weekdays.SUN;
      case 1: return Weekdays.MON;
      case 2: return Weekdays.TUE;
      case 3: return Weekdays.WED;
      case 4: return Weekdays.THU;
      case 5: return Weekdays.FRI;
      case 6: return Weekdays.SAT;
    }

    return null;
  }

  static get all():Weekday[]
  {
    let weekdays = 
    [
      Weekdays.MON,
      Weekdays.TUE,
      Weekdays.WED,
      Weekdays.THU,
      Weekdays.FRI,
      Weekdays.SAT,
      Weekdays.SUN
    ];

    return weekdays;
  }
}